import { useQuery, UseQueryResult } from 'react-query';
import { fetchAnalysts } from '../../services/analysts/analysts.service';
import { Analyst } from '../../models';
import { queryKeys } from '../queryKeyFactory';

const analystsParams = { skip: 0, take: 1000 };

export default (): UseQueryResult<Analyst[]> => {
  return useQuery([queryKeys.fetchAllAnalysts, analystsParams], async () => {
    const analysts = await fetchAnalysts(analystsParams);
    return analysts;
  });
};
